"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const apiGlobalTypes_1 = require("api/types/apiGlobalTypes");
const addOrEditInvoice_1 = require("../store/addOrEditInvoice");
const index_1 = require("api/index");
const helper_1 = require("../helper");
const store_1 = require("core/store");
const queryString_1 = require("core/helpers/queryString");
const react_router_dom_1 = require("react-router-dom");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const react_1 = require("react");
const useMediaFileUploads_1 = tslib_1.__importDefault(require("../../../../../hooks/useMediaFileUploads"));
const useAddEditInvoice = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const [state, dispatch] = (0, addOrEditInvoice_1.useInvoiceReducer)();
    const [signatories, setSignatories] = (0, react_1.useState)({ data: [], errors: null });
    const [sumPrice, setSumPrice] = (0, react_1.useState)(0);
    const [showDeclineMessage, setShowDeclineMessage] = (0, react_1.useState)(false);
    const [showSuspendMessage, setShowSuspendMessage] = (0, react_1.useState)(false);
    const [deletingFiles, setDeletingFiles] = (0, react_1.useState)([]);
    const [showDeleteFileAlert, setShowDeleteFileAlert] = (0, react_1.useState)(null);
    const [generatingTemplate, setGeneratingTemplate] = (0, react_1.useState)(false);
    const [invoiceId, setInvoiceId] = (0, react_1.useState)(undefined);
    const [invoicesParamsIds, setInvoicesParamsIds] = (0, react_1.useState)({ invoiceIds: [], meta: store_1.initialMeta });
    const [buttonNavigate, setButtonNavigate] = (0, react_1.useState)(addOrEditInvoice_1.initialInvoiceNavigate);
    const [listingParams, setListingParams] = (0, react_1.useState)('?');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const { getFileProperties } = (0, useMediaFileUploads_1.default)({ url: 'documents/purchases/invoices/file-upload' });
    const getInvoice = async (id) => {
        dispatch({ type: 'SEND_INVOICE_REQUEST' });
        const invoice = await index_1.InvoicesApi.getInvoice(id);
        if (invoice.data && invoice.data.invoiceFile && !invoice.data.invoiceFile.link) {
            const fileResponse = await getFileProperties(invoice.data.invoiceFile.id, invoice.data.invoiceFile.extension);
            if (fileResponse && fileResponse.data)
                invoice.data.invoiceFile.link = fileResponse.data.link;
        }
        dispatch({ type: 'DONE_INVOICE_REQUEST', payload: invoice });
    };
    const updateInvoiceFine = async (id, fine) => {
        dispatch({ type: 'SEND_INVOICE_FINE_REQUEST' });
        const invoice = await index_1.InvoicesApi.updateInvoiceFine(id, fine);
        dispatch({ type: 'DONE_INVOICE_FINE_REQUEST', payload: invoice });
        return invoice;
    }; // todo @Davit ამოსაშლელი მიღება/ჩაბარებაში ჯარიმის გასწორების შემდეგ
    const declineInvoice = async (message, InvoiceId, invoiceFile) => {
        dispatch({ type: 'SEND_INVOICE_DECLINE' });
        setShowDeclineMessage(false);
        const invoice = await index_1.InvoicesApi.declineInvoice(message, InvoiceId);
        if (invoice.data && invoice.data.invoiceFile && invoiceFile)
            invoice.data.invoiceFile.link = invoiceFile.link;
        dispatch({ type: 'DONE_INVOICE_DECLINE', payload: invoice });
        return invoice;
    };
    const suspendInvoice = async (message, InvoiceId, invoiceFile) => {
        dispatch({ type: 'SEND_INVOICE_SUSPEND' });
        setShowSuspendMessage(false);
        const invoice = await index_1.InvoicesApi.suspendInvoice(message, InvoiceId);
        if (invoice.data && invoice.data.invoiceFile && invoiceFile)
            invoice.data.invoiceFile.link = invoiceFile.link;
        dispatch({ type: 'DONE_INVOICE_SUSPEND', payload: invoice });
        return invoice;
    };
    const changeStatus = async (id, invoiceFile) => {
        dispatch({ type: 'SEND_CHANGE_STATUS' });
        const invoice = await index_1.InvoicesApi.changeStatus(id);
        if (invoice.data && invoice.data.invoiceFile && invoiceFile)
            invoice.data.invoiceFile.link = invoiceFile.link;
        dispatch({ type: 'DONE_CHANGE_STATUS', payload: invoice });
        return invoice;
    };
    const changeSubStatus = async (id, invoiceFile) => {
        dispatch({ type: 'SEND_CHANGE_SUB_STATUS' });
        const invoice = await index_1.InvoicesApi.changeSubStatus(id);
        if (invoice.data && invoice.data.invoiceFile && invoiceFile)
            invoice.data.invoiceFile.link = invoiceFile.link;
        dispatch({ type: 'DONE_CHANGE_SUB_STATUS', payload: invoice });
        return invoice;
    };
    const createInvoice = async (values) => {
        const params = (0, helper_1.transformInvoiceParams)(values);
        dispatch({ type: 'SEND_INVOICE_CREATE' });
        const invoice = await index_1.InvoicesApi.createInvoice(params);
        dispatch({ type: 'DONE_INVOICE_CREATE', payload: invoice });
        return invoice;
    };
    const createInvoiceWithItems = async (invoiceFormValues, updateInvoiceItemsList, invoiceItems) => {
        if (invoiceId) {
            const itemResponse = await updateInvoiceItemsList(invoiceId, invoiceItems);
            if (itemResponse)
                navigate(`/documents/purchases/invoices/${invoiceId}/edit`);
        }
        else {
            const invoice = await createInvoice(invoiceFormValues);
            if (invoice.data && invoice.data.id && !invoiceId) {
                setInvoiceId(invoice.data.id);
                const itemResponse = await updateInvoiceItemsList(invoice.data.id, invoiceItems, true);
                if (itemResponse.errors === null) {
                    getLastFirstElementStatus(invoice.data.id);
                    navigate(`/documents/purchases/invoices/${invoice.data.id}/edit`);
                    return { errors: itemResponse.errors, status: itemResponse.status };
                }
                else {
                    return {
                        status: apiGlobalTypes_1.ResponseStatuses.UNEXPECTED,
                        errors: [{
                                name: 'created_invoice_but_failed_item_add',
                                message: 'შეიქმნა ინვოისი, მაგრამ ვერ მოხდა შესყიდვის საგნების დამატება'
                            }]
                    };
                }
            }
            else {
                return { errors: invoice.errors, status: invoice.status };
            }
        }
        return null;
    };
    const updateInvoice = async (id, values, updateInvoiceItemsList, invoiceItems) => {
        const params = (0, helper_1.transformInvoiceParams)(values);
        dispatch({ type: 'SEND_INVOICE_UPDATE' });
        const invoice = await index_1.InvoicesApi.updateInvoice(id, params);
        if (invoice.data && invoice.data.invoiceFile && values.invoiceFile)
            invoice.data.invoiceFile.link = values.invoiceFile.link;
        dispatch({ type: 'DONE_INVOICE_UPDATE', payload: invoice });
        if (state.data.procurement.id !== params.procurementId) {
            if (invoice.status === apiGlobalTypes_1.ResponseStatuses.SUCCESS) {
                const invoiceItemsResponse = await updateInvoiceItemsList(id, invoiceItems).then();
                return invoiceItemsResponse.errors === null
                    ? { errors: null, status: apiGlobalTypes_1.ResponseStatuses.SUCCESS }
                    : { status: invoiceItemsResponse.status, errors: invoiceItemsResponse.errors };
            }
            else {
                return { errors: [{
                            name: 'document_success_but_failed_items_update',
                            message: translate('updated_invoice_but_not_items', 'განახლდა ინვოისი, მაგრამ ვერ მოხდა შესყიდვის საგნების განახლება')
                        }], status: invoice.status };
            }
        }
        return { errors: invoice.errors, status: invoice.status };
    };
    const closeErrorMessage = (index) => {
        dispatch({ type: 'REMOVE_ERROR', payload: index });
    };
    const deleteInvoiceFile = async (id) => {
        setDeletingFiles(prev => [...prev, id]);
        const invoiceFile = await index_1.InvoicesApi.deleteInvoiceFile(props.id, { fileUids: [id] });
        setDeletingFiles(prev => prev.filter(el => el !== id));
        return { status: invoiceFile.status, errors: invoiceFile.errors };
    };
    const generateInvoiceTemplate = async (id) => {
        setGeneratingTemplate(true);
        const invoice = await index_1.InvoicesApi.generateInvoiceTemplate(id);
        setGeneratingTemplate(false);
        return invoice;
    };
    const getInvoiceIds = async (values) => {
        const onlyMine = await localStorage.getItem('invoiceOnlyMine') || undefined;
        const invoiceParams = (0, helper_1.transformInvoiceParamsToFilterParams)({ ...values, onlyMine });
        const itemsParams = (0, helper_1.getItemsParamsFromUrl)(location.search);
        const invoices = await index_1.InvoicesApi.getInvoices(invoiceParams);
        if (invoices.data !== null && invoices.meta) {
            const responseIds = { invoiceIds: invoices.data.map(el => el.id), meta: invoices.meta };
            const searchParams = (0, queryString_1.stringify)({ ...(0, helper_1.transformFilterParamsToUrl)(values), ...itemsParams });
            setListingParams(searchParams || '?');
            setInvoicesParamsIds(responseIds);
            return responseIds;
        }
        return null;
    };
    const nextInvoice = async () => {
        setButtonNavigate(prevState => ({ ...prevState, next: true, isLoading: true }));
        const currentIndex = invoicesParamsIds.invoiceIds.indexOf(props.id);
        const nextInvoice = invoicesParamsIds.invoiceIds[currentIndex + 1];
        const { pagination } = invoicesParamsIds.meta;
        const params = (0, helper_1.transformFilterParamsToUrl)((0, helper_1.getParamsFromUrl)(location.search));
        if (nextInvoice) {
            const itemsParams = (0, helper_1.getItemsParamsFromUrl)(location.search);
            navigate('/documents/purchases/invoices/' + nextInvoice + '/edit' + (0, queryString_1.stringify)({ ...params, ...itemsParams }));
            const lastElement = pagination.currentPage === pagination.totalPages && invoicesParamsIds.invoiceIds.length === currentIndex + 2;
            setButtonNavigate(prevState => ({ ...prevState, next: false, firstElement: false, lastElement, isLoading: false }));
        }
        else {
            if (pagination.currentPage === pagination.totalPages) {
                setButtonNavigate(prevState => ({ ...prevState, next: false, lastElement: true, isLoading: false }));
                return;
            }
            const formValues = (0, helper_1.getParamsFromUrl)(location.search);
            const response = await getInvoiceIds({ ...formValues, page: pagination.currentPage + 1 });
            if (response && response.invoiceIds[0]) {
                formValues.page = response.meta.pagination.currentPage;
                const itemsParams = (0, helper_1.getItemsParamsFromUrl)(location.search);
                const urlParams = { ...(0, helper_1.transformFilterParamsToUrl)(formValues), page: response.meta.pagination.currentPage, ...itemsParams };
                navigate('/documents/purchases/invoices/' + response.invoiceIds[0] + '/edit' + (0, queryString_1.stringify)(urlParams));
                const lastElement = response.meta.pagination.currentPage === response.meta.pagination.totalPages && response.invoiceIds.length === 1;
                setButtonNavigate(prevState => ({ ...prevState, next: false, firstElement: false, lastElement, isLoading: false }));
            }
        }
    };
    const previousInvoice = async () => {
        setButtonNavigate(prevState => ({ ...prevState, previous: true, isLoading: true }));
        const currentIndex = invoicesParamsIds.invoiceIds.indexOf(props.id);
        const prevInvoice = invoicesParamsIds.invoiceIds[currentIndex - 1];
        const { pagination } = invoicesParamsIds.meta;
        const params = (0, helper_1.transformFilterParamsToUrl)((0, helper_1.getParamsFromUrl)(location.search));
        if (prevInvoice) {
            const itemsParams = (0, helper_1.getItemsParamsFromUrl)(location.search);
            navigate('/documents/purchases/invoices/' + prevInvoice + '/edit' + (0, queryString_1.stringify)({ ...params, ...itemsParams }));
            const firstElement = pagination.currentPage === 1 && currentIndex === 1;
            setButtonNavigate(prevState => ({ ...prevState, previous: false, lastElement: false, firstElement, isLoading: false }));
        }
        else {
            if (pagination.currentPage === 1) {
                setButtonNavigate(prevState => ({ ...prevState, previous: false, firstElement: true, isLoading: false }));
                return;
            }
            const formValues = (0, helper_1.getParamsFromUrl)(location.search);
            const response = await getInvoiceIds({ ...formValues, page: pagination.currentPage - 1 });
            if (response) {
                const previousInvoice = response.invoiceIds[response.invoiceIds.length - 1];
                if (previousInvoice) {
                    formValues.page = response.meta.pagination.currentPage;
                    const itemsParams = (0, helper_1.getItemsParamsFromUrl)(location.search);
                    const urlParams = { ...(0, helper_1.transformFilterParamsToUrl)(formValues), page: response.meta.pagination.currentPage, ...itemsParams };
                    navigate('/documents/purchases/invoices/' + previousInvoice + '/edit' + (0, queryString_1.stringify)(urlParams));
                    const firstElement = response.meta.pagination.currentPage === 1 && currentIndex === 1;
                    setButtonNavigate(prevState => ({ ...prevState, previous: false, lastElement: false, firstElement, isLoading: false }));
                }
            }
        }
    };
    const getLastFirstElementStatus = (id) => {
        const params = (0, helper_1.getParamsFromUrl)(location.search);
        params.onlyMine = localStorage.getItem('invoiceOnlyMine') || undefined;
        getInvoiceIds(params).then(response => {
            if (response) {
                const { currentPage, totalPages } = response.meta.pagination;
                const invoiceIndex = response.invoiceIds.indexOf(id || props.id);
                if (invoiceIndex === 0 && currentPage === 1)
                    setButtonNavigate(prevState => ({ ...prevState, firstElement: true }));
                if (currentPage === totalPages && invoiceIndex === response.invoiceIds.length - 1) {
                    setButtonNavigate(prevState => ({ ...prevState, lastElement: true }));
                }
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (props.id)
            getLastFirstElementStatus(props.id);
    }, []);
    (0, react_1.useEffect)(() => { if (props.id)
        getInvoice(props.id).then(); }, [props.id]);
    return {
        state,
        createInvoice,
        updateInvoice,
        declineInvoice,
        changeStatus,
        changeSubStatus,
        showDeclineMessage,
        setShowDeclineMessage,
        signatories,
        getInvoice,
        suspendInvoice,
        setShowSuspendMessage,
        showSuspendMessage,
        closeErrorMessage,
        setSignatories,
        setSumPrice,
        sumPrice,
        deleteInvoiceFile,
        showDeleteFileAlert,
        deletingFiles,
        setShowDeleteFileAlert,
        generateInvoiceTemplate,
        generatingTemplate,
        invoiceId,
        setInvoiceId,
        createInvoiceWithItems,
        listingParams,
        previousInvoice,
        buttonNavigate,
        nextInvoice,
        updateInvoiceFine // todo @Davit ამოსაშლელი მიღება/ჩაბარებაში ჯარიმის გასწორების შემდეგ
    };
};
exports.default = useAddEditInvoice;
